import { sendEmailLetter } from '@/api/services/helpersApi';
import { LETTERS_CONFIGS } from '@/constants/letters';
import { getTemplateLetterForBafsy, getTemplateLetterForUser } from '@/helpers/processingMethods';
import { EmailSenderConfig } from '@/types/types';

export const sendLetter = async (
  subtitle: string,
  content: string,
  email: string,
  emailSender: null | { name: string; email: string } = null,
) => {
  /*const config: Record<string, unknown> = {
    'email[subject]': subtitle,
    'email[html]': content,
    'email[to][][email]': email,
  };

  if (emailSender) {
    config['email[from][name]'] = emailSender.name;
    config['email[from][email]'] = emailSender.email;
  }*/

  const config: EmailSenderConfig = {
    email: {
      subject: subtitle,
      html: content,
      to: [{ email: email }],
      custom_unsubscribe_link: '1',
    },
  };

  if (emailSender) {
    config.email.from = {
      name: emailSender.name,
      email: emailSender.email,
    };
  }

  return await sendEmailLetter(config);
};

export const sendBafsyLetter = async (typeLetter: string, content: Record<string, unknown>) => {
  const config = LETTERS_CONFIGS[typeLetter];

  if (!config) return Promise.reject({ status: 404, data: null, state: 'failed' });

  return await sendLetter(
    config.us.subtitle,
    getTemplateLetterForBafsy(
      Object.keys(content)
        .map((key) => `<b>${key}</b>: ${content[key]}`)
        .join('<br>'),
    ),
    import.meta.env.VITE_LETTER_RECIPIENTS,
    { name: 'Поддержка Bafsy', email: 'support@bafsy.com' },
  );
};

export const sendUserLetter = async (typeLetter: string, email: string) => {
  const config = LETTERS_CONFIGS[typeLetter];

  if (!config) return Promise.reject({ status: 404, data: null, state: 'failed' });

  return await sendLetter(
    config.user.subtitle,
    getTemplateLetterForUser(config.user.content, config.user.subtitle),
    email,
    { name: 'Bafsy', email: 'sales@bafsy.com' },
  );
};
